import React from 'react';
import PropTypes from 'prop-types';
import YoutubeVideoEmbed from 'epic-react-common/src/components/YoutubeVideoEmbed';

export default class Video extends React.Component {
    static propTypes = {
        video: PropTypes.string,
        play: PropTypes.bool,
        close: PropTypes.func
    };

    videoOptions = {
        playerVars: {
            width: '100%',
            height: '100%',
            showinfo: 0,
            controls: 1,
            autohide: 0,
            cc_load_policy: 0,
            disablekb: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            rel: 0,
            loop: 0
        }
    };

    render() {
        const videoId = this.props.video;
        return (
            <div id="video" className="video-container">
                <span role="presentation" className="video-modal-close" onClick={this.props.close}>×</span>
                <div className="video-iframe-wrapper">
                    <YoutubeVideoEmbed
                        video={videoId}
                        videoOptions={this.videoOptions}
                        mute={false}
                        loop={true}
                        play={this.props.play} />
                </div>
            </div>
        );
    }
}
